/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as LabelDefs from './defs.defs.js'

const $nsid = 'com.atproto.label.subscribeLabels'

export { $nsid }

/** Subscribe to stream of labels (and negations). Public endpoint implemented by mod services. Uses same sequencing scheme as repo event stream. */
const main = l.subscription(
  $nsid,
  l.params({ cursor: l.optional(l.integer()) }),
  l.typedUnion(
    [
      l.typedRef<Labels>((() => labels) as any),
      l.typedRef<Info>((() => info) as any),
    ],
    false,
  ),
  ['FutureCursor'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Message = l.InferSubscriptionMessage<typeof main>

export const $lxm = main.nsid,
  $params = main.parameters,
  $message = main.message

type Labels = {
  $type?: 'com.atproto.label.subscribeLabels#labels'
  seq: number
  labels: LabelDefs.Label[]
}

export type { Labels }

const labels = l.typedObject<Labels>(
  $nsid,
  'labels',
  l.object({
    seq: l.integer(),
    labels: l.array(l.ref<LabelDefs.Label>((() => LabelDefs.label) as any)),
  }),
)

export { labels }

type Info = {
  $type?: 'com.atproto.label.subscribeLabels#info'
  name: 'OutdatedCursor' | l.UnknownString
  message?: string
}

export type { Info }

const info = l.typedObject<Info>(
  $nsid,
  'info',
  l.object({
    name: l.string<{ knownValues: ['OutdatedCursor'] }>(),
    message: l.optional(l.string()),
  }),
)

export { info }
